<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <g transform="translate(3.759 1.716)">
            <path d="M8.242,20.568a.681.681,0,0,1-.475-.194C5.945,18.62,0,12.588,0,8.56A8.416,8.416,0,0,1,8.243,0a8.038,8.038,0,0,1,5.828,2.508A8.662,8.662,0,0,1,16.483,8.56c0,4.025-5.945,10.06-7.767,11.813A.679.679,0,0,1,8.242,20.568Zm0-16.375A3.9,3.9,0,0,0,4.423,8.16a3.9,3.9,0,0,0,3.821,3.967A3.9,3.9,0,0,0,12.065,8.16,3.9,3.9,0,0,0,8.243,4.193Z" transform="translate(0 0)" fill="#59C638"/>
        </g>
    </svg>
</template>
